<template>
    <div class="position-box">
        <div class="head">
          <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
          <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
          <div class="title">{{$t('zyzs.title')}}</div>
        </div>
        <div class="cotainer">
          <div class="zy-box">
					<div class="check-box"><label for="zy">{{$t('zyzs.zy')}}</label><input class="checkbox" type="checkbox" name="zy" id="zy" checked /></div>
				</div>
				<div class="price-box">
					<div class="input-box"><input class="input" type="number" min="0" :placeholder="$t('zyzs.qsrzyjg')"  v-model="stop_profit" @keyup="keyProfit()" /></div>
					<div class="text">USDT</div>
				</div>
				<div class="zy-box">
					<div class="check-box"><label for="zs">{{$t('zyzs.zs')}}</label><input class="checkbox" checked type="checkbox" id="zs" name="zs" /></div>
				</div>
				<div class="price-box">
					<div class="input-box"><input class="input" type="number" min="0" :placeholder="$t('zyzs.qsrzsjg')"  @keyup="keyLoss()" v-model="stop_loss" /></div>
					<div class="text">USDT</div>
				</div>
				<div class="btn-box">
					<button class="btn btn-bg" type="button" @click="sure">{{$t('zyzs.qr')}}</button>
				</div>
				<div class="wxts">
					<div class="cont">{{$t('zyzs.wxts')}}{{$t('zyzs.cont')}}</div>
				</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'profitLoss',
    data () {
        return {
            theme: false,
            id: '',
						tradeIdx: '',
						price: '',
						stop_profit: '',//止盈
						stop_loss: ''//	止损
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.id = this.$route.query.id;
      this.stop_profit = this.stop_loss = this.$route.query.price;
      this.tradeIdx = this.$route.query.tradeIdx;
    },
    mounted() {
        this.getList()
    },
    methods: {
      back(){
        this.$router.push({ path: '/perpetualContract', query: { tradeIdx: this.tradeIdx } })
      },
      sure(){
        let that = this;
        if(that.stop_profit == ''){
          this.$toast.center(this.$t('zyzs.qsrzyjg'));
          return false;
        }
        if(that.stop_loss == ''){
          this.$toast.center(this.$t('zyzs.qsrzsjg'));
          return false;
        }
        let params = {
          id: that.id,
          stop_profit: parseFloat(that.stop_profit),
          stop_loss: parseFloat(that.stop_loss)
        }
        this.$ajax.post('/web/editPosition',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.$toast.center(resData.message);
                setTimeout(() => {
                  this.$router.push({ path: '/perpetualContract', query: { tradeIdx: that.tradeIdx } })
                },1500)
            }else{
                this.$toast.center(resData.message);
                return;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      keyProfit(){
        this.stop_profit = this.stop_profit.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.stop_profit = this.stop_profit.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.stop_profit = this.stop_profit.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.stop_profit = this.stop_profit.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.stop_profit.indexOf(".") < 0 && this.stop_profit != "") { //首位是0的话去掉
          this.stop_profit = parseFloat(this.stop_profit);
        }
      },
      keyLoss(){
        this.stop_loss = this.stop_loss.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.stop_loss = this.stop_loss.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.stop_loss = this.stop_loss.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.stop_loss = this.stop_loss.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.stop_loss.indexOf(".") < 0 && this.stop_loss != "") { //首位是0的话去掉
          this.stop_loss = parseFloat(this.stop_loss);
        }
      },
      toFixed(v) {
        return parseFloat(v).toFixed(4)
      },
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        padding: 0 .36rem;
        background: #fff;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .zy-box{
        padding: .84rem 0 .66rem;
    }
    .zy-box .check-box{
        display: flex;
        align-items: center;
        position: relative;
    }
    .zy-box .check-box .checkbox{
        position: relative;
        margin-left: 8px;
        width: .48rem;
        height: .48rem;
    }
    .zy-box .check-box .checkbox::after{
        position: absolute;
        width: .48rem;
        height: .48rem;
        content: '';
        background: url('../assets/Check-box.png') no-repeat center center;
        background-size: .48rem .48rem;
    }
    .zy-box .check-box .checkbox:checked::after{
        position: absolute;
        width: .48rem;
        height: .48rem;
        content: '';
        background: url('../assets/Check-box-succeed.png') no-repeat center center;
        background-size: .48rem .48rem;
    }
    .price-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.2rem;
        padding: 0 .42rem;
        color: #ccc;
        line-height: 1.2rem;
        border: 1px solid #d7d7d7;
        border-radius: .12rem;
    }
    .price-box .input-box{
        flex: 1;
    }
    .price-box .input-box .input{
        width: 100%;
        height: 1.2rem;
    }
    .price-box .text{
        padding-left: .3rem;
    }
    .zyzs-tips{
        padding: .66rem 0 .6rem;
        color: #a3a3a3;
    }
    .radio-wrap{
        display: flex;
        align-items: center;
    }
    .radio-wrap .radio-list:last-child{
        margin-left: 1.8rem;
    }
    .radio-wrap .radio-box{
        display: flex;
        align-items: center;
        position: relative;
        color: #a3a3a3;
    }
    .radio-wrap .radio-box .radio{
        position: relative;
        margin-right: 8px;
        width: .48rem;
        height: .48rem;
    }
    .radio-wrap .radio-box .radio::after{
        position: absolute;
        width: .48rem;
        height: .48rem;
        content: '';
        background: url('../assets/no-chose_gray.png') no-repeat center center;
        background-size: .48rem .48rem;
    }
    .radio-wrap .radio-box .radio:checked::after{
        position: absolute;
        width: .48rem;
        height: .48rem;
        content: '';
        background: url('../assets/chose_light.png') no-repeat center center;
        background-size: .48rem .48rem;
    }
    .wxts{
        margin-top: .66rem;
        padding: .36rem 0;
        color: #a3a3a3;
        font-size: .36rem;
        border-top: 1px solid #fafafa;
    }
    .wxts .cont{
        padding-top: .36rem;
    }
    .btn-box {
        position: absolute;
        left: 0;
        bottom: .72rem;
        width: 100%;
        padding: 0 .36rem;
        box-sizing: border-box;
    }
    .btn-box .btn {
        display: block;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/profitLoss.vue